import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页', icon: 'ri-home-3-line' },
    { to: '/category/all', label: '漫画分类', icon: 'ri-grid-line' },
    { to: '/about', label: '关于我们', icon: 'ri-information-line' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-sword-line text-lg text-background-50"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
            刃牙漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = link.to === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-900'
                }`}
              >
                <i className={`${link.icon} text-base`}></i>
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 text-foreground-600 hover:text-foreground-900 hover:border-foreground-300 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-search-line"></i>
          </button>
          <Link
            to="/category/all"
            className="flex items-center gap-1.5 px-5 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 text-foreground-700 cursor-pointer whitespace-nowrap"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={mobileOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 space-y-1">
          {navLinks.map((link) => {
            const isActive = link.to === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} text-base`}></i>
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/category/all"
            className="flex items-center justify-center gap-2 px-4 py-3 mt-2 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            开始阅读
          </Link>
        </div>
      )}
    </header>
  );
}